var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileSearch = function SvgIconFileSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.375 13.875a3.25 3.25 0 1 1 6.144 1.48l1.17 1.17a1 1 0 0 1-1.415 1.413l-1.169-1.169a3.25 3.25 0 0 1-4.73-2.894m3.25-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.25A1.75 1.75 0 0 1 18.75 22H5.25a1.75 1.75 0 0 1-1.75-1.75V3.75A1.75 1.75 0 0 1 5.25 2h9a1 1 0 0 1 .707.293l5.25 5.25a1 1 0 0 1 .293.707zM5.5 20V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20zM17.46 7.625h-2.585V5.039z"
  }))));
};
export default SvgIconFileSearch;